import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60 || !isHome);
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHome]);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/movie', label: '电影' },
    { to: '/category/tv', label: '电视剧' },
    { to: '/category/variety', label: '综艺' },
    { to: '/category/anime', label: '动漫' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50 shadow-sm border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className={`font-heading text-2xl font-bold ${scrolled ? 'text-primary-600' : 'text-white'}`}>
              天堂影院
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-3 py-2 text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === link.to
                    ? scrolled
                      ? 'bg-primary-100 text-primary-700 font-medium'
                      : 'bg-white/20 text-white font-medium'
                    : scrolled
                      ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                      : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-2">
            <button
              onClick={() => navigate('/category/movie')}
              className={`w-9 h-9 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
                scrolled ? 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100' : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              <i className="ri-search-line text-lg"></i>
            </button>
          </div>

          <button
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer ${
              scrolled ? 'text-foreground-700' : 'text-white'
            }`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="打开菜单"
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-3 py-2.5 text-sm rounded-lg whitespace-nowrap cursor-pointer ${
                  location.pathname === link.to
                    ? 'bg-primary-100 text-primary-700 font-medium'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}